const awsconfig = {
  Auth: {
    region: process.env.GATSBY_APP_REGION,
    userPoolId: process.env.GATSBY_USER_POOL_ID,
    userPoolWebClientId: process.env.GATSBY_USER_POOL_WEB_CLIENT_ID,
    identityPoolId: process.env.GATSBY_IDENTITY_POOL_ID,
    oauth: {
      domain: process.env.GATSBY_COGNITO_DOMAIN,
      scope: ['email', 'openid'],
      redirectSignIn: process.env.GATSBY_CALLBACK_URL,
      redirectSignOut: process.env.GATSBY_CALLBACK_URL,
      responseType: 'code',
    },
  },
  aws_appsync_graphqlEndpoint: process.env.GATSBY_API_ENDPOINT,
  aws_appsync_region: process.env.GATSBY_APP_REGION,
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  Storage: {
    AWSS3: {
      bucket: process.env.GATSBY_AMPLIFY_S3_STORAGE_BUCKET,
      region: process.env.GATSBY_APP_REGION,
    }
  }, 
};

export default awsconfig;
